import { MutualFundListItem } from '../power-rebalancing/MutualFundList'
import MutualFundListItemSkeleton from '../skeletons/MutualFundListItemSkeleton'
import { PowerPerformanceForms } from '../../types/mutual-fund-detail.types'
import { useBottomSheet } from '../../state-management/contexts/BottomSheetContext'
import RegularToDirectBottomSheet from './RegularToDirectBottomSheet'
import { RegularToDirectSummaryResponse } from '../../types/regular-to-direct-plan.types'
import { trackEvent } from '../../utils/appBridge'
import { EventNames } from '../../types/misc.types'

const toPerformanceForm = (rating: any): PowerPerformanceForms => {
  if (Object.values(PowerPerformanceForms).includes(rating as PowerPerformanceForms)) {
    return rating as PowerPerformanceForms
  }
  return PowerPerformanceForms.NOT_RATED
}

interface RegularPlanListProps {
  summaryData: RegularToDirectSummaryResponse | undefined
  isLoading: boolean
  isError: boolean
}

export default function RegularPlanList({ summaryData, isLoading, isError }: RegularPlanListProps) {
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()

  if (isLoading) {
    return (
      <div className='pt-8'>
        <div className='text-lg font-medium leading-[1.2] px-4 pb-4'>Regular Funds</div>
        <div>
          {[...Array(3)].map((_, index) => (
            <MutualFundListItemSkeleton key={index} isLast={index === 2} showChevron={true} />
          ))}
        </div>
      </div>
    )
  }

  if (isError || !summaryData) {
    return null
  }


  const nonExitedFunds = summaryData.regularFunds.filter((fund) => !fund.exited)

  if (nonExitedFunds.length === 0) {
    return null
  }

  return (
    <div className='pt-8'>
      <div className='text-lg font-medium leading-[1.2] px-4 pb-4'>Regular Funds</div>
        {nonExitedFunds.map((fund, index) => {
          const isLast = index === nonExitedFunds.length - 1
          const performanceForm = toPerformanceForm(fund.performanceRating)

          return (
            <>
            {/* // <div key={fund.isin}> */}
              <MutualFundListItem
                isin={fund.isin}
                name={fund.name}
                fundNature={fund.fundNature}
                fundCategory={fund.fundCategory}
                purchaseMode={fund.purchaseMode}
                powerRank={fund.powerRank}
                performanceRating={performanceForm}
                missedGains={0}
                highExposure={false}
                mfLogoUrl={fund.mfLogoUrl}
                formType={performanceForm}
                sipAmount={0}
                isRegular={fund.purchaseMode === 'REGULAR'}
                riskProfile={null}
                borderRequired={true}
                isLast={isLast}
                onClick={() => {
                  trackEvent({
                    eventName: EventNames.UserClicked,
                    payload: {
                      eventId: 'RegularFundClick',
                      responseName: 'Open',
                      screenType: 'REGULAR_TO_DIRECT_PLAN_PAGE'
                    }
                  })
                  openBottomSheet(
                    <RegularToDirectBottomSheet
                      fundName={fund.name}
                      regularFundValue={fund.regularFundValue}
                      onDismiss={() => {
                        trackEvent({
                          eventName: EventNames.UserClicked,
                          payload: {
                            eventId: 'RegularToDirectBottomSheet',
                            responseName: 'Close',
                            screenType: 'REGULAR_TO_DIRECT_PLAN_PAGE'
                          }
                        })
                        closeBottomSheet()
                      }}
                      isRegular={fund.purchaseMode === 'REGULAR'}
                      mfLogoUrl={fund.mfLogoUrl}
                      name={fund.name}
                      fundNature={fund.fundNature}
                      fundCategory={fund.fundCategory}
                      performanceRating={performanceForm}
                      ScreenName='REGULAR_TO_DIRECT_PLAN_PAGE'
                    />
                  )
                }}
                additionalCommissionsPaid={fund.additionalCommissionsPaid}
              />
              </>
            // </div>
          )
        })}
    </div>
  )
}
